type DividerProps = {
    title: string;
};

export default function Divider({ title }: DividerProps) {
    return (
        <div className="w-full">
            <div className="flex items-center gap-4 justify-center py-4">
                <div className="h-px flex-1 bg-[var(--outline-default)]"></div>
                <span className="text-sm text-[var(--outline-default)]">{title}</span>
                <div className="h-px flex-1 bg-[var(--outline-default)]"></div>
            </div>
        </div>
    );
} 
